import type { Style } from '@wix/thunderbolt-becky-types'
import { createCompNode } from '@wix/thunderbolt-catharsis'
import { isRefArray, isVariantRelation } from '../../utils/variantsUtils'

export const isStylable = createCompNode({
	getDependencies: (component, refs) => {
		return component.styleId ? refs.styleId(component.styleId) : undefined
	},
	toViewItem: (__, style) => {
		const defaultStyle = isRefArray(style)
			? (style.values.find((s) => !isVariantRelation(s)) as Style | undefined)
			: style

		const properties = defaultStyle?.style?.properties
		return !!properties && ('st-css' in properties || '$st-css' in properties)
	},
})
